import type { SectionBlock } from "./statement-schema";

/** What a technician is pointing at when they question a figure. */
export interface StatementItemReference {
  heading?: string;
  line?: string;
  amount?: string;
}

/** Builds every question target rendered by a statement section. */
export const getSectionItemReferences = (
  block: SectionBlock,
): StatementItemReference[] =>
  block.items.flatMap((item) => [
    {
      heading: block.heading,
      line: item.title,
      amount: item.amount,
    },
    ...(item.fields ?? [])
      .filter((field) => field.label)
      .map((field) => ({
        heading: item.title,
        line: field.label ?? undefined,
        amount: field.value,
      })),
  ]);
